// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CreditCardTwoToneSvg from "@fishx/icons-svg/es/asn/CreditCardTwoTone";
import FishxIcon from '../components/FishxIcon';

var CreditCardTwoTone = function CreditCardTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardTwoToneSvg
  }));
};

CreditCardTwoTone.displayName = 'CreditCardTwoTone';
export default React.forwardRef(CreditCardTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CreditCardTwoTone.js
// module id = 2348
// module chunks = 0